import { Component, OnInit } from '@angular/core';
import { EVENTS } from './data-events';

@Component({
  selector: 'app-events-page',
  templateUrl: './events-page.component.html',
  styleUrls: ['./events-page.component.scss']
})
export class EventsPageComponent implements OnInit {
  events = EVENTS;
  constructor() { }

  ngOnInit(): void {
    this.events;
  }

}
